import React, { memo, useCallback, useEffect } from 'react';

import { Title } from '@components/Title';
import { OutsideClickListener } from '@components/OutsideClickListener';

import { useThemeGetter, useWindowDimensions } from '@hooks';

import {
  mainInfo,
  ExperienceInfo,
  ExperienceItemIds,
  ExperienceDefault,
} from '@consts';
import { EScreenTypes } from '@enum';

import { selectCurrentExperience } from '@redux/selectors';
import { ExperienceSlice } from '@redux/reducers/experience';
import { useAppDispatch, useAppSelector } from '@redux/hooks';

import { JobList } from './JobList';
import { JobDescription } from './JobDescription';

import { getBlockState } from './JobBlock.utils';

import { JobBlockContainer, JobSliderContainer } from './JobBlock.styled';

export const JobBlock = memo(() => {
  const {
    theme: { Title: TitleColor },
  } = useThemeGetter();
  const { type } = useWindowDimensions();
  const defaultClicked =
    type === EScreenTypes.mobile
      ? mainInfo.EXPERIENCE_INFO[0].id
      : ExperienceItemIds.non_exist;

  const dispatch = useAppDispatch();

  const clickedPosition = useAppSelector(selectCurrentExperience);

  const { setExperience } = ExperienceSlice.actions;

  const handleChangeClickedPosition = useCallback((id: ExperienceItemIds) => {
    dispatch(setExperience(id));
  }, []);

  const handleClickOutside = useCallback(() => {
    type !== EScreenTypes.mobile && dispatch(setExperience(defaultClicked));
  }, [type]);

  const getCurrentJob = (id: ExperienceItemIds): ExperienceInfo => {
    const currentJob = mainInfo.EXPERIENCE_INFO.find((one) => one.id === id);
    return currentJob ?? ExperienceDefault;
  };

  useEffect(() => {
    if (
      type === EScreenTypes.mobile &&
      clickedPosition === ExperienceItemIds.non_exist
    ) {
      dispatch(setExperience(defaultClicked));
    }
  }, [type]);

  return (
    <JobBlockContainer>
      <Title text="History" size={3} color={TitleColor} />
      <OutsideClickListener action={handleClickOutside}>
        <JobSliderContainer
          isBlockActive={
            getBlockState(clickedPosition) || type === EScreenTypes.mobile
          }
        >
          <JobList
            onClick={handleChangeClickedPosition}
            active={clickedPosition}
          />
          <JobDescription {...getCurrentJob(clickedPosition)} />
        </JobSliderContainer>
      </OutsideClickListener>
    </JobBlockContainer>
  );
});
